export default "/images/1f7d8883526400a8249c38f5aeaf92ad.avif";